export const CHARGE_NUMBERS = [1, 2, 3] as const;

export const ASSET_IDS = {
  EAF: 11,
  LMF: 12,
  CASTER: 13,
} as const;

export const GRID_DIMENSIONS = {
  ROW_HEIGHT: 36,
  HEADER_HEIGHT: 36,
  DEFAULT_PADDING: 72,
  MIN_ROWS: 5,
} as const;
